import { FieldDefinition } from "./fieldDefinitions";

export interface RehabProtocolDto {
  rehabId: number;
  protocolType: string;
}
export const rehabProtocolKeyId = "rehabId" as const;

export const rehabProtocolFields: FieldDefinition[] = [
  { name: "rehabId", label: "Επώνυμο", type: "text", required: true },
  { name: "protocolType", label: "Όνομα", type: "text", required: true },
] as const;

export const userFilters = rehabProtocolFields.filter((f) =>
  ["rehabId", "protocolType"].includes(f.name),
);

export const rehabProtocolFormData: string[] = ["protocolType"];
